<template>
     <div v-show="parent3Show">
        <Form ref="formItem" :model="formData" style="max-width:600px" :rules="formValidate" :label-width="100">
            <Form-item label="任务名称">
                <Input disabled type="text" v-model="formItem.wname"></Input>
            </Form-item>
            <Form-item label="水印">
                <Input disabled type="text" v-model="formItem.watermark"></Input>
            </Form-item>
            <Form-item label="模板">
                <Input disabled type="text" v-model="formItem.name"></Input>
            </Form-item>
            <Form-item label="开始时间">
                <Input disabled type="text" v-model="formItem.sdate"></Input>
            </Form-item>
            <Form-item label="截止时间">
                <Input disabled type="text" v-model="formItem.edate"></Input>
            </Form-item>
            <Form-item label="门店" prop="stores">
                <Row>
                    <Col span="18">
                        <Input v-model="formData.stores" type="textarea" placeholder="请输入..."></Input>
                    </Col>
                    <Col span="6">
                        <Button type="ghost" style="margin-left:8px" icon="ios-cloud-upload-outline" @click="$refs.upload.click()">上传文件</Button>（仅限.txt格式）
                        <input type="file" @change="fileChange" style="display:none" ref="upload">
                    </Col>
                </Row>
            </Form-item>
            <Form-item>
                <Button type="primary" @click="submitFn('formItem')">提交</Button>
            </Form-item>
        </Form>
    </div>
</template>
<script>
    export default {
        data(){
            const storelistRegexp = (rule, value, callback) => {    //门店校验
                if(value != null && value != ''){
                    if(!/^\d+(,\d+)*$/.test(value)){
                        callback(new Error('门店包含特殊符号，请检查！'));
                    }else{
                        callback();
                    }
                }else{
                    callback(new Error('门店不能为空'));
                }
            };
            return{
                formItem:{
                    wname:'',
                    watermark:'',
                    temid:'',
                    sdate:'',
                    edate:'',
                    stores:'',
                },
                formData:{
                    stores:'',
                },
                formValidate:{
                    stores: [
                        { required: true, validator: storelistRegexp, trigger: 'change' }
                    ],
                },
            }
        },
        watch:{
            $route(to,from){
                if(to.path == '/taskList/addToTask'){
                    this.$store.dispatch('parent3ShowFn');
                };
            }
        },
        computed: {
            parent3Show () {
                return this.$store.state.parent3Show;
            }
        },
        created(){
            this.$store.dispatch('parent3ShowFn');
            this.getData();
        },
        methods:{
            submitFn(name){
                var _this=this;
                this.$refs[name].validate((valid) => {
                    if(valid){
                        _this.$http.post('/web/workorder/addTaskWithWorkOrder',{
                            woid:_this.$route.query.woid,
                            storelist:_this.formData.stores
                        }).then(function(res){
                            if(res.success){
                                _this.$Notice.success({
                                    title:'添加任务',
                                    desc:res.message
                                });
                                _this.$router.push({path:'/projectList/taskList',query:{bigid:_this.$route.query.bigid}});
                            }else{
                                _this.$Notice.error({
                                    title:'添加任务',
                                    desc:res.message
                                });
                            }
                        }).catch(function(res){
                            _this.$Notice.error({
                                title:'添加任务',
                                desc:'数据请求失败'
                            });
                        });
                    }else{
                        _this.$Message.error('表单提交失败');
                    }
                });
            },
            getData(){
                var _this=this;
                this.$http.get('/web/workorder/getWorkOrderMsg',{
                    params:{
                        woid:_this.$route.query.woid
                    }
                }).then(function(res){
                    if(res.success){
                        _this.formItem=res.data;
                    }else{
                        _this.$Notice.error({
                            title:'获取数据',
                            desc:res.message,
                        });
                    }
                }).catch(function(res){
                    _this.$Notice.error({
                        title:'获取数据',
                        desc:'数据请求失败'
                    });
                });
            },
            fileChange(){
                var _this=this;
                var inputDOM = this.$refs.upload;
                if (!inputDOM['value'].match(/.txt/i)){     //判断上传文件格式
                    return alert("上传的文件格式不正确，请重新选择（仅限txt格式）");
                }
                var file = inputDOM.files[0];
                var reader = new FileReader();
                reader.onload = function () {
                    var string= this.result;
                    try{
                        string=string.replace(/\r\n/g,",");
                        string=string.replace(/\n/g,",");
                        _this.formData.stores=string;
                    }catch(e) {
                        alert(e.message);
                    }
                };
                reader.readAsText(file);
            },
        },
    }
</script>
<style scoped>
    .hd{ background:#464c5b; color:#fff; }
    h3{ background:#dddee1; padding:2px 5px 2px 20px; line-height:30px; margin-top:-1px; }
</style>


// WEBPACK FOOTER //
// src/components/task/addToTask.vue